export interface LinksModalProps {
  showModal: boolean;
  onHide: (val: boolean) => void;
  type?: string;
  handleApplyFromLink?: Function;
  url?: string;
}

export interface QuickLinksTabsProps {
  setActiveTab: (val: string) => void;
  activeTab: string;
  type?: string;
  setSelectedLink: (val: any) => void;
  setSelectedTypeTabOpen: (val: string) => void;
}

export interface ModalBodyProps {
  setActiveTab: (val: string) => void;
  activeTab: string;
  setSelectedTypeTabOpen: (val: string) => void;
  selectedTypeTabOpen: string;
  setSelectedDirection: (val: string) => void;
  selectedDirection: string;
  setSelectedLink: (val: any) => void;
  selectedLink: any;
  type?: string;
}
export interface RenderBodyContentProps {
  activeTab: string;
  setSelectedTypeTabOpen: (val: string) => void;
  selectedTypeTabOpen: string;
  setSelectedDirection: (val: string) => void;
  selectedDirection: string;
  setCourseLinkTypeSelection: (val: string[]) => void;
  courseLinkTypeSelection: string[];
  setSelectedLink: (val: any) => void;
  selectedLink: any;
}

export const typeSelectionForForm = {
  Modules: 'Modules',
  pages: 'Pages',
  Assignments: 'Assignments',
  Discussions: 'Discussions',
  Quizzes: 'Quizzes',
  Announcements: 'Announcements',
  'Course Navigation': 'Course Navigation',
  Files: 'Files',
};
export const tabs = [
  { key: 'courselinks', label: 'Course Links' },
  { key: 'webaddress', label: 'Web Address' },
  { key: 'email', label: 'Email' },
];
export interface TabTypeSelectionProps {
  setSelectedTypeTabOpen: (val: string) => void;
  selectedTypeTabOpen: string;
}
export interface PaginatedListProps {
  modules: CourseLink[];
  setPageNo: (val: number) => void;
  isNextPage: boolean;
  pageNo: number;
  isLoading: boolean;
  setCourseLinkTypeSelection: (val: string[]) => void;
  courseLinkTypeSelection: string[];
  selectedType: string;
  setPageNoCollaction: (val: number[]) => void;
  pageNoCollaction: number[];
  setItems: React.Dispatch<React.SetStateAction<any[][]>>;
  items: any[][];
  setCurrentPage: (val: number) => void;
  currentPage: number;
  setCurrentItems: (val: any[]) => void;
  currentItems: any[];
  response: any;
  setSelectedLink: (val: any) => void;
  selectedLink: any;
  setisApiCall: (val: boolean) => void;
}
export interface CourseLink {
  id: number;
  name: string;
  items_url: string;
}

export interface ModuleData {
  data: {
    sortingCourseLinks: {
      statusCode: number;
      body: CourseLink[];
      nextPage: boolean;
    };
  };
}
